// Module
var code = "<div class=\"c-datatable-moreButtonCell u-sizeFullWidth ui-grid-cell-contents\" title=\"{{COL_FIELD CUSTOM_FILTERS}}\">\n    <div class=\"u-flex u-flexMiddle u-flexSpaced\">\n        <div>{{row.entity.expirationDate | date :\"shortDate\" }}</div>\n    </div>\n</div>\n";
// Exports
module.exports = code;